import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import ShiftPlannerIMg from "../../../../../Assets/Images/CycleLandingImage.png";
import { ReducersTypes } from "../../../../../Constants";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});
const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px dashed rgb(102, 102, 102)",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
  borderWidth: 2,
};
class LeaveTransition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actionidlist: "",
      value: 0,
      transition: [],
      loading: false,
      permissions: { readOnly: false, editable: false },
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("leaveTransition");
  }

  componentWillUnmount() {
    this.props.CommonReducerAction(`${ReducersTypes.LANGUAGE}_PENDING`);
    this.setHelperText("");
  }

  setHelperText = (key) => {
    this.props.setHelperText({ helperText: key });
  };

  componentDidMount() {
    this.props.setHelperText({
      helperText: "Helper text for Leave Plan",
      open: false,
    });
    const [isTrue, permissions] = CheckActionPermission("transition");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getLeaveTransitionDetails();
      });
    } else {
      // this.props.history.push('404')
      this.setState({ permissiondenied: true });
    }
  }

  getLeaveTransitionDetails() {
    this.setState({ loading: true }, () =>
      instance
        .get("/leaves/subscriptionleavetransition")
        .then((result) => {
          let transition = [];
          result.data.result.length > 0
            ? (transition = result.data.result)
            : (transition = []);
          this.setState({ loading: false });
          if (transition[0].leavetransitionid == null) {
          } else {
            this.props.history.push({
              pathname: "./leavetransitionform",
              state: { permissions: this.state.permissions },
            });
          }
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        }),
    );
  }

  CreateTransition(e) {
    this.props.history.push({
      pathname: "./leavetransitionform",
      state: { permissions: this.state.permissions },
    });
  }

  handleChange = (event) => {
    this.setState({ value: event.text });
  };

  showLoader() {
    return <div className="pre-loader">Loading...</div>;
  }

  render() {
    const language = this.props.Language.leaveTransition;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="innerwrapper-full-width">
          <div className="innerwrapperheader">
            <div className="innerwrapper-page-header">
              Leave / Leave Transition
            </div>
          </div>

          {this.state.loading == true ? (
            this.showLoader()
          ) : (
            <React.Fragment>
              <Grid container className="margin-left-30">
                <Grid item xs={12} md={6} sm={12}>
                  <h5>
                    {" "}
                    <FormattedMessage
                      id="LbTransitionHeading"
                      defaultMessage="Concept of Leave Transition"
                    />
                  </h5>
                  <p
                    className="transition-desc"
                    style={{ textAlign: "justify" }}
                  >
                    <FormattedMessage
                      id="LbTransitionContent"
                      defaultMessage="When a calendar or financial year comes to an end, leave balance of employees either lapses, gets carried forward or encashed based on the Leave Policies available to them."
                    />
                  </p>
                  <div className="margin-top-60">
                    {this.state.permissions.editable ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        type="button"
                        onClick={this.CreateTransition.bind(this)}
                      >
                        <FormattedMessage
                          id="BtCreateTransition"
                          defaultMessage="CREATE"
                        />
                      </Button>
                    ) : (
                      ""
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={6} sm={12}>
                  <img src={ShiftPlannerIMg} align="right" />
                </Grid>
              </Grid>
            </React.Fragment>
          )}
        </div>
      </IntlProvider>
    );
  }
}

LeaveTransition.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(LeaveTransition)));
